import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_AUDIOSTORAGE_API_URL;

const axios = createAxiosInstance(URL, { withouthAuth: true });

export const fetchConcatenateInfo = () => {
    return axios.get('/api/v1/concatenate_info/get/');
};
